import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EccellenzaChimicaNelDistrettoDiPrato from "./sections/EccellenzaChimicaNelDistrettoDiPrato";
import LeNostreForniture from "./sections/LeNostreForniture";
import AffidabilitEStoriaDal1978 from "./sections/AffidabilitEStoriaDal1978";
import ContattaIlNostroUfficioTecnico from "./sections/ContattaIlNostroUfficioTecnico";
import LaNostraSede from "./sections/LaNostraSede";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EccellenzaChimicaNelDistrettoDiPrato />
      <LeNostreForniture />
      <AffidabilitEStoriaDal1978 />
      <ContattaIlNostroUfficioTecnico />
      <LaNostraSede />
      <Footer />
    </div>;
}